
export const ORGANIZATIONS_RECEIVED = "ORGANIZATIONS_RECEIVED";
export const ADMIN_ORGANIZATIONS_RECEIVED = "ADMIN_ORGANIZATIONS_RECEIVED";
export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const CREATE_ORGANIZATION = "CREATE_ORGANIZATION";
export const SET_PROPERTY_ORGANIZATION = "SET_PROPERTY_ORGANIZATION";
export const SET_PROPERTY_USER_ORGANIZATION = "SET_PROPERTY_USER_ORGANIZATION";
export const SET_USER_ORGANIZATION = "SET_USER_ORGANIZATION";
export const SET_ORGANIZATION_TO_EDIT = "SET_ORGANIZATION_TO_EDIT";
export const SET_INTERCEPTOR = "SET_INTERCEPTOR";